module.exports = __webpack_public_path__ + "img/icon-eye.ed8bdd4c.svg";